/* eslint-disable @tanstack/query/no-deprecated-options */
import axios from "axios";

export async function downloadFileFromSignedUrl(
  signedUrl: string,
  fileName: string,
): Promise<string | null> {
  try {
    const response = await axios({
      url: signedUrl,
      method: "GET",
      responseType: "blob",
    });

    const blobUrl = window.URL.createObjectURL(
      new Blob([response.data as BlobPart]),
    );

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);

    return null;
  } catch (err) {
    return err instanceof Error ? err.message : String(err);
  }
}

export default downloadFileFromSignedUrl;
